import { Concierge } from './Concierge';
import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Books } from '@phosphor-icons/react';

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("concierge")) return [];
    return [
      {
        route: "/concierge",
        icon: <Books className="text-lg" />,
        label: "Client OS",
        href: "/concierge",
        order: 1,
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("concierge")) return [];
    return [
      {
        path: "/concierge",
        element: <Concierge name="Client OS" />,
      },
    ];
  }
};

export { Concierge };

